import axios from 'axios';
import {APP_DOMAIN} from 'constants/AppPath';
import {AuthenticationService, authHeader} from 'services/access/AuthenticationService';
import {hideProgress, showProgress} from "../../components/ProgressCustom";
import {showErrorBox} from "../../components/MessageBox";
import {FTUTrans} from "../../components/FTUComponent";
import React from "react";

export const Utils = {
    get,
    getExpUrl,
    getByUrl,
    del,
    post,
    postByUrl,
    put,
    postLogin,
    postLogout,
    _format,
    _urlRender
};

async function get(path, data, func, hasDialogProcess = false, responseType) {
    let url = Utils._urlRender(path, data);
    const requestOptions = {headers: authHeader()};
    if (responseType) {
        requestOptions.responseType = responseType;
    }
    if (hasDialogProcess) {
        showProgress();
    }
    //
    if (func) {
        return axios.get(url, requestOptions).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            func(res)
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 ||
                error.response.status === 403)) {
                AuthenticationService.logout();
                window.location.replace("/permission/" + error.response.data.code);
            } else {
                //showErrorBox(<FTUTrans ns="common" name="error.common"/>);
            }
            if (hasDialogProcess) {
                hideProgress();
            }
        });
    } else {
        return axios.get(url, requestOptions).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            return res;
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 ||
                error.response.status === 403)) {
                AuthenticationService.logout();
                window.location.replace("/permission/" + error.response.data.code);
            } else {
                //showErrorBox(<FTUTrans ns="common" name="error.common"/>);
            }
            if (hasDialogProcess) {
                hideProgress();
            }
        });
    }
};

async function getExpUrl(path, data, func, hasDialogProcess = false, responseType) {
    let url = Utils._urlRender(path, data);
    const requestOptions = {headers: authHeader()};
    if (responseType) {
        requestOptions.responseType = responseType;
    }
    if (responseType) {
        requestOptions.responseType = responseType;
    }
    if (hasDialogProcess) {
        showProgress();
    }
    if (func) {
        return axios.get(url, requestOptions).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            func(res)
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 ||
                error.response.status === 403)) {
                AuthenticationService.logout();
                window.location.replace("/permission/" + error.response.data.code);
            } else {
                //showErrorBox(<FTUTrans ns="common" name="error.common"/>);
            }
            if (hasDialogProcess) {
                hideProgress();
            }
        });
    } else {
        return axios.get(url, requestOptions).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            return res;
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 ||
                error.response.status === 403)) {
                AuthenticationService.logout();
                window.location.replace("/permission/" + error.response.data.code);
            } else {
                //showErrorBox(<FTUTrans ns="common" name="error.common"/>);
            }
            if (hasDialogProcess) {
                hideProgress();
            }
        });
    }
};

async function getByUrl(path, data, func, hasDialogProcess = false, responseType) {
    let url = _format(path, data);
    const requestOptions = {headers: authHeader()};
    if (responseType) {
        requestOptions.responseType = responseType;
    }
    if (hasDialogProcess) {
        showProgress();
    }
    //
    if (func) {
        return axios.get(url, requestOptions).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            func(res)
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 ||
                error.response.status === 403)) {
                AuthenticationService.logout();
                window.location.replace("/permission/" + error.response.data.code);
            } else {
                //showErrorBox(<FTUTrans ns="common" name="error.common"/>);
            }
            if (hasDialogProcess) {
                hideProgress();
            }
        });
    } else {
        return axios.get(url, requestOptions).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            return res;
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 ||
                error.response.status === 403)) {
                AuthenticationService.logout();
                window.location.replace("/permission/" + error.response.data.code);
            } else {
                //showErrorBox(<FTUTrans ns="common" name="error.common"/>);
            }
            if (hasDialogProcess) {
                hideProgress();
            }
        });
    }
};

async function del(path, data, func, hasDialogProcess = false, responseType) {
    let url = Utils._urlRender(path, data);
    const requestOptions = {headers: authHeader()};
    if (responseType) {
        requestOptions.responseType = responseType;
    }
    if (hasDialogProcess) {
        showProgress();
    }
    //
    if (func) {
        return axios.delete(url, requestOptions).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            func(res)
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 ||
                error.response.status === 403)) {
                AuthenticationService.logout();
                window.location.replace("/permission/" + error.response.data.code);
            } else {
                //showErrorBox(<FTUTrans ns="common" name="error.common"/>);
            }
            if (hasDialogProcess) {
                hideProgress();
            }
        });
    } else {
        return axios.delete(url, requestOptions).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            return res;
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 ||
                error.response.status === 403)) {
                AuthenticationService.logout();
                window.location.replace("/permission/" + error.response.data.code);
            } else {
                //showErrorBox(<FTUTrans ns="common" name="error.common"/>);
            }
            if (hasDialogProcess) {
                hideProgress();
            }
        });
    }
};

async function post(path, data, func, hasDialogProcess = false, responseType) {
    let url = Utils._urlRender(path, null);
    const requestOptions = {
        headers: Object.assign(authHeader(),
            {'Content-Type': 'application/json'})

    };
    if (responseType) {
        requestOptions.responseType = responseType;
    }
    if (hasDialogProcess) {
        showProgress();
    }
    //
    if (func) {
        return axios.post(url, data, requestOptions).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            func(res)
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 ||
                error.response.status === 403)) {
                AuthenticationService.logout();
                window.location.replace("/permission/" + error.response.data.code);
            } else {
                //showErrorBox(<FTUTrans ns="common" name="error.common"/>);
            }
            if (hasDialogProcess) {
                hideProgress();
            }
        });
    } else {
        return axios.post(url, data, requestOptions).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            return res;
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 ||
                error.response.status === 403)) {
                AuthenticationService.logout();
                window.location.replace("/permission/" + error.response.data.code);
            } else {
                //showErrorBox(<FTUTrans ns="common" name="error.common"/>);
            }
            if (hasDialogProcess) {
                hideProgress();
            }
        });
    }
};

async function postByUrl(url, data, func, hasDialogProcess = false, responseType) {
    const requestOptions = {
        headers: Object.assign(authHeader(),
            {'Content-Type': 'application/json'})

    };
    if (responseType) {
        requestOptions.responseType = responseType;
    }
    if (hasDialogProcess) {
        showProgress();
    }
    //
    if (func) {
        return axios.post(url, data, requestOptions).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            func(res)
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 ||
                error.response.status === 403)) {
                AuthenticationService.logout();
                window.location.replace("/permission/" + error.response.data.code);
            } else {
                //showErrorBox(<FTUTrans ns="common" name="error.common"/>);
            }
            if (hasDialogProcess) {
                hideProgress();
            }
        });
    } else {
        return axios.post(url, data, requestOptions).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            return res;
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 ||
                error.response.status === 403)) {
                AuthenticationService.logout();
                window.location.replace("/permission/" + error.response.data.code);
            } else {
                //showErrorBox(<FTUTrans ns="common" name="error.common"/>);
            }
            if (hasDialogProcess) {
                hideProgress();
            }
        });
    }
};

async function put(path, data, func, hasDialogProcess = false, responseType) {
    let url = Utils._urlRender(path, null);
    const requestOptions = {
        headers: Object.assign(authHeader(),
            {'Content-Type': 'application/json'})

    };
    if (responseType) {
        requestOptions.responseType = responseType;
    }
    if (hasDialogProcess) {
        showProgress();
    }
    //
    if (func) {
        return axios.put(url, data, requestOptions).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            func(res)
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 ||
                error.response.status === 403)) {
                AuthenticationService.logout();
                window.location.replace("/permission/" + error.response.data.code);
            } else {
                //showErrorBox(<FTUTrans ns="common" name="error.common"/>);
            }
            if (hasDialogProcess) {
                hideProgress();
            }
        });
    } else {
        return axios.put(url, data, requestOptions).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            return res;
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 ||
                error.response.status === 403)) {
                AuthenticationService.logout();
                window.location.replace("/permission/" + error.response.data.code);
            } else {
                //showErrorBox(<FTUTrans ns="common" name="error.common"/>);
            }
            if (hasDialogProcess) {
                hideProgress();
            }
        });
    }
};

async function postLogin(path, data, func, hasDialogProcess = false) {
    let url = Utils._urlRender(path, null);
    let config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    if (hasDialogProcess) {
        showProgress();
    }
    //
    if (func) {
        return axios.post(url, data, config).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            func(res)
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 || error.response.status === 403)) {

                AuthenticationService.logout();
            }
            if (hasDialogProcess) {
                hideProgress();
            }
            func(error.response);
        });
    } else {
        return axios.post(url, data, config).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            return res;
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 ||
                error.response.status === 403)) {
                AuthenticationService.logout();
                window.location.replace("/permission/" + error.response.data.code);
            } else {
                //showErrorBox(<FTUTrans ns="common" name="error.common"/>);
            }
            if (hasDialogProcess) {
                hideProgress();
            }
        });
    }
};

async function postLogout(path, data, func, hasDialogProcess = false) {
    let url = Utils._urlRender(path, null);
    const requestOptions = {
        headers: Object.assign(authHeader(),
            {'Content-Type': 'application/json'})

    };
    if (hasDialogProcess) {
        showProgress();
    }
    //
    if (func) {
        return axios.post(url, data, requestOptions).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            func(res)
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 ||
                error.response.status === 403)) {
                window.location.replace("/permission/" + error.response.data.code);
            } else {
                //showErrorBox(<FTUTrans ns="common" name="error.common"/>);
            }
            if (hasDialogProcess) {
                hideProgress();
            }
        });
    } else {
        return axios.post(url, data, requestOptions).then(res => {
            if (hasDialogProcess) {
                hideProgress();
            }
            return res;
        }).catch(error => {
            if (error && error.response && error.response.status && (error.response.status === 401 ||
                error.response.status === 403)) {
                window.location.replace("/permission/" + error.response.data.code);
            } else {
                //showErrorBox(<FTUTrans ns="common" name="error.common"/>);
            }
            if (hasDialogProcess) {
                hideProgress();
            }
        });
    }
};

function _urlRender(path, data) {
    let url = APP_DOMAIN + (path.indexOf('/') === 0 ? path : ('/' + path));
    if (data) {
        url += "?";
        for (var key in data) {
            url += key + "=" + encodeURI(data[key]) + "&";
        }
        url = url.replace(/&$/, "");
    }
    return url;
};

function _format(url, data) {
    let result = url;
    for (let k in data) {
        result = result.replace("{" + k + "}", data[k]);
    }
    return result;
}
